const config = {
    recaptchaV2_site_key: "6Le1AZkbAAAAANAIcMsqZ7ylc7DzYNaUhCtyei8L"
}

export default config;